export const environment = {
	production: true,
	AsamcoAppSettings: {
		b2c: {
			enabled: true,
			scope: '/api/user_impersonation',
			client_id: 'df40e88d-159b-4c94-98f0-b6532fc739a7',
			signinPolicy: 'B2C_1A_SIGNUP_SIGNIN_V6',
			forgotPasswordPolicy: 'B2C_1A_PASSWORDRESET_V6',
			tenant: 'ApplicationLinkB2C',
			silentRenewalOffset: 300,
			maxAllowedIATOffset: 300,
		},
		homePage: '',
		userApprovalEnabled: true,
		childOrigin: 'https://asamcocdn.azureedge.net',
		evoUrl: 'https://asamcocdn.azureedge.net/evo/{version}/index.html',
		appName: 'Applicationlink',
		appId: 'application-link',
		userSessionStorageKey: 'al-usersession',
		assetsDirectory: 'assets/',
		authPin: 1337,
		customerId: 334,
		databaseId: 1,
		databaseNamePrefix: 'AAS',
		iconPath: 'assets/img/user-01.jpg',
		logoPath: 'assets/img/logo/logo_high_res.png',
		menuLogoPath: 'assets/img/logo/logo_high_res.png',
		showUserAvatar: false,
		nestApprove: false,
		nestTimeline: false,
		offlineLogin: true,
		saveSettingsInLocalStorage: false,
		serverId: 1,
		legacyEpoDeployFolder: '/epo/{epo-version}/',
		serverProviderAddress: 'http://serverprovider.asamco.com/api/server/get/',
		serversLocalStorageKey: 'SERVERS',
		showLocate: true,
		showLogoutWarning: true,
		showResetPassword: false,
		showUsermoduleLogin: false,
		showRegister: true,
		showMicrosoftLogin: true,
		showGoogleLogin: false,
		showServerSettings: false,
		appVersion: '1.0.1',
		allowActiveDirectoryLogin: true,
		licensingEnabled: false,
		isSignalREnabled: true,
		serverSettings: {
			1: {
				header: 'Guid',
				loginUrl: 'UserLogin/Login',
				checkUrl: 'UserLogin/CheckInSession',
				dbListUrl: 'lookup/dblist',
			},
			2: {
				header: 'Authorization: Bearer',
				loginUrl: 'OauthAuthentication/GetToken',
				logoutUrl: 'OauthAuthentication/Logout',
				checkUrl: 'permission/AuthenticatedUserPermissions',
				dbListUrl: 'serverinfo/databases',
			},
			3: {
				baseUrl: '/api/',
				checkUrl: '',
				databaseId: -1,
				dbListUrl: '',
				header: 'Authorization: Bearer',
				isPrimary: true,
				loginUrl: '',
				logoutUrl: '',
				serverId: -1,
				token: null,
			},
		},
		test: {
			name: 'superadmin',
			pass: 'superadmin',
		},
	},
};
